module.exports = __webpack_public_path__ + "static/media/firstBg.680bf88e.png";